import { render, staticRenderFns } from "./view-accident-details.vue?vue&type=template&id=1b4f7e7a&"
import script from "./view-accident-details.vue?vue&type=script&lang=js&"
export * from "./view-accident-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports